<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="nursingScheduling">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            护理排班
        </div>
        <div style="padding: 20px;">

            <div>
                <el-row>
                    <el-button type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>
                    <el-button type="success" :disabled="disabledEdit" @click.native="handleEdit">编辑</el-button>
                    <el-button type="danger" :disabled="disabledRecord" @click.native="editInfo">修改记录</el-button>
                    <div style="float:right">
                        <span class="demonstration">起止时间：</span>
                        <el-date-picker
                            ref="picker"
                            v-model="datetimerangeValue"
                            type="daterange"
                            :clearable='false'
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width:250px;margin-right:20px">
                        </el-date-picker>
                        <el-button  type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
            </div>



            <div style="height: 10px;"></div>

            <div :style="styleTh">
                
                <el-calendar v-model="calendarDate" :range='range'>
                    <template
                        slot="dateCell"
                        slot-scope="{date, data}">
                        <p :class="isSelecteds(date) ? 'is-selected' : ''">
                        {{ data.day.split('-').slice(1).join('-') }} {{ isSelecteds(date) ? '✔️' : ''}}
                        </p>
                        <el-form label-position="left" inline class="demo-table-expand"  v-if="getDayInfo(date)">
                            <div v-if="getDayInfo(date).type==2">
                                <el-form-item label="白班：">
                                    <span v-for="item in getDayInfo(date).nursingSchedulingDaytime.nursingSchedulingDaytimeItemList" :key="item.dishesCode">
                                        <span v-show="item.nurseName">护士：{{item.nurseName}}<br></span>
                                        <span v-show="item.nurseAideName">护工：{{item.nurseAideName}}<br></span>
                                    </span>
                                </el-form-item>
                                <el-form-item label="夜班：">
                                    <span v-for="item in getDayInfo(date).nursingSchedulingNighttime.nursingSchedulingNighttimeItemList" :key="item.dishesCode">
                                        <span v-show="item.nurseName">护士：{{item.nurseName}}<br></span>
                                        <span v-show="item.nurseAideName">护工：{{item.nurseAideName}}<br></span>
                                    </span>
                                </el-form-item>
                            </div>
                            <div  v-if="getDayInfo(date).type==3">
                                <el-form-item label="早班：">
                                    <span v-for="item in getDayInfo(date).nursingSchedulingMorning.nursingSchedulingMorningItemList" :key="item.dishesCode">
                                        <span v-show="item.nurseName">护士：{{item.nurseName}}<br></span>
                                        <span v-show="item.nurseAideName">护工：{{item.nurseAideName}}<br></span>
                                    </span>
                                </el-form-item>
                                <el-form-item label="中班：">
                                    <span v-for="item in getDayInfo(date).nursingSchedulingNoon.nursingSchedulingNoonItemList" :key="item.dishesCode">
                                        <span v-show="item.nurseName">护士：{{item.nurseName}}<br></span>
                                        <span v-show="item.nurseAideName">护工：{{item.nurseAideName}}<br></span>
                                    </span>
                                </el-form-item>
                                <el-form-item label="晚班：">
                                    <span v-for="item in getDayInfo(date).nursingSchedulingNight.nursingSchedulingNightItemList" :key="item.dishesCode">
                                        <span v-show="item.nurseName">护士：{{item.nurseName}}<br></span>
                                        <span v-show="item.nurseAideName">护工：{{item.nurseAideName}}<br></span>
                                    </span>
                                </el-form-item>
                            </div>
                        </el-form>
                    </template>
                </el-calendar>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-bind:nurseList="nurseList" v-bind:nurseAideList="nurseAideList" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-bind:nurseList="nurseList" v-bind:nurseAideList="nurseAideList" v-on:getList="getList"></Edit>
        <Info ref="myInfo" v-show="showModalInfo" v-on:closeInfo="showModalInfo=false"></Info>
    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Edit from "./Edit";
    import Add from "./Add";
    import Info from "./Info";
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:true,
                showModalAdd:false,
                showModalEdit:false,
                showModalInfo:false,
                menuButtonList:null,
                disabledAdd:true,
                disabledEdit:true,
                disabledRecord:true,
                nurseAideList:[],
                nurseList:[],
                tableData:[],
                totalItems: 0,
                dateList:[],
                pageSize:20,
                currentPage:1,
                datetimerangeValue:'',
                calendarDate:'',
                range:[],
                th:0,
                styleTh:{
                    height:'',
                    background:'#fff',
                    'overflow-y':'auto'
                },

            }
        },
        components:{
            Add,Edit,Info
        },
        created(){
            this.init();
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
            this.styleTh.height=this.$store.state.tableHeight+50+'px';
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
                this.styleTh.height=val+50+'px';
            },
            calendarDate(val){
                this.getDate(val)
            }
        },
        methods:{
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="添加"){
                            this.disabledAdd = false;
                        }
                        if(menu[i].buttonName=="编辑"){
                            this.disabledEdit = false;
                        }
                        if(menu[i].buttonName=="修改记录"){
                            this.disabledRecord = false;
                        }
                    }
                }
            },
            init(){
                const start= new Date();
                const end=new Date(start.getTime() + 1000 * 60 * 60 * 24 * 15);
                this.datetimerangeValue=[start, end];
                this.getWeekDate(this.datetimerangeValue)
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Nurse/List",
                    data: { 
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode:getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.nurseList=response.data.data
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"NurseAide/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode:getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.nurseAideList=response.data.data
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            editInfo(){
                this.showModalInfo=true
                this.$refs.myInfo.init();
            },
            getWeekDate(date){
                var startDate=new Date(date[0])
                startDate.setDate(startDate.getDate() - startDate.getDay() + 1);
                var endDate=new Date(date[1])
                endDate.setDate(endDate.getDate() - endDate.getDay() + 7);
                this.range=[timefilters(startDate).slice(0,10),timefilters(endDate).slice(0,10)]
            },
            timefilter(row, column, cellValue){
                return timefilters(cellValue)
            },
            isSelecteds(date){
                var list=this.dateList
                var getDate=timefilters(date).slice(0,10)
                if(list.indexOf(getDate)>-1){
                    return true
                }
                return false
            },
            getDayInfo(data){
                var list=this.tableData
                var row=''
                list.forEach(element => {
                    if(timefilters(element.time).slice(0,10)==timefilters(data).slice(0,10)){
                        row=element
                    }
                });
                return row
            },
            getDate(date){
                var newDate=timefilters(new Date()).slice(0,10)
                var getDate=timefilters(date).slice(0,10)
                if(new Date(newDate)<=new Date(date)){
                    var list=this.dateList
                    if(list.indexOf(getDate)>-1){
                        list.splice(list.indexOf(getDate), 1)
                    }else{
                        list.push(getDate)
                    }
                    this.dateList=list
                }else{
                    this.$message.error('只能编辑今天以及今天以后的排班')
                }
            },
            handleEdit() {
                if(!this.dateList.length){
                    this.$message.error('请选择排班日期')
                    return
                }
                if(this.dateList.length>1){
                    this.$message.error('只能编辑单个排班')
                    return
                }
                var row=this.getDayInfo(this.dateList[0])
                if(!row){
                    this.$message.error('请先添加,再修改')
                    return
                }
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd:function(){
                if(!this.dateList.length){
                    this.$message.error('请选择排班日期')
                    return
                }
                var row;
                for(var i in this.dateList){
                    if(this.getDayInfo(this.dateList[i])){
                        this.$message.error('请去除已排班日期，已排班日期可通过修改编辑')
                        row=this.getDayInfo(this.dateList[i]) 
                        break;
                    }
                }
                if(!row){
                    this.showModalAdd = true;
                    this.$refs.myAdd.init(this.dateList);
                }else{
                    return
                }
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(){
                this.loading = true;
                this.getWeekDate(this.datetimerangeValue)
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"NursingScheduling/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                        startTime:this.range[0],
                        endTime:this.range[1],
                    }
                }).then( (response)=> {
                    this.loading = false;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                        this.dateList=[]
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },



        }
    }
</script>
<style lang="scss" scoped>
.nursingScheduling{
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width:100%;
    }
     .calendar-day{
        text-align: center;
        color: #202535;
        line-height: 30px;
        font-size: 12px;
    }
    .is-selected{
            color: #F8A535;
            /* font-size: 10px;
            margin-top: 5px; */
        }
    /deep/ .el-calendar-table .el-calendar-day {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        height: 250px;
        overflow-y: auto;
    }
    .el-calendar-table .el-calendar-click {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 8px;
        height: 100px;
    }
    .el-calendar-table thead th {
        padding: 6px 0;
        color: #606266;
        font-weight: normal;
        text-align: center;
    }
    /deep/  .el-calendar-day::-webkit-scrollbar {width: 2px;}
    /deep/  .el-calendar-day::-webkit-scrollbar-thumb {
        border-radius: 10px;
        display: none;
        // -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: #00FFFF;
    }
    /deep/ .el-calendar-day::-webkit-scrollbar-track {
        // -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: transparent;
    }
}
 
</style>
